import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import EmailSuccessfullyVerifiedModal from '@/modules/user/components/ContactVerification/EmailSuccessfullyVerifiedModal';
import { getHashValue } from '@/utils/modifiers/getHashValue';

import { DashboardModalsKeys } from './dashboardModals.types';

const DashboardModals = () => {
  const location = useLocation();
  const modalHash = getHashValue(location.hash);
  const [activeModalHash, setActiveModalHash] = useState<DashboardModalsKeys | null>(null);

  useEffect(() => {
    if (modalHash) {
      setActiveModalHash(modalHash as DashboardModalsKeys);
      window.history.replaceState('', document.title, window.location.pathname);
    }
  }, [modalHash]);

  const handleCloseModal = useCallback(() => {
    setActiveModalHash(null);
  }, []);

  const activeModal = useMemo(() => {
    switch (activeModalHash) {
    case DashboardModalsKeys.EmailSuccessfullyVerified: 
      return <EmailSuccessfullyVerifiedModal onSetVisible={handleCloseModal} />;
    default:
      return null;
    }
  }, [activeModalHash, handleCloseModal]);

  return activeModal;
};

export default DashboardModals;
